import {
  Box,
  Button,
  CircularProgress,
  FormHelperText,
  Grid,
  IconButton,
  Skeleton,
  Tooltip,
} from "@mui/material";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";

import { Template } from "features/Influencer/ContactList/schema";
import TemplateBody from "features/Influencer/Templates/SharedComponents/TemplateBody";
import UtilizeMergeTags from "features/Influencer/Templates/SharedComponents/UtilizeMergeTag";

const loadingMessages = [
  "Scoring your template...",
  "Evaluating tone, structure, and personalization...",
  "Putting together your rubric breakdown...",
];

interface Props {
  createLoading: boolean;
  editTemplate: Template;
  setEditTemplate: Dispatch<SetStateAction<Template>>;
  followupTemplate: Template;
  setFollowupTemplate: Dispatch<SetStateAction<Template>>;
  setIsDirty: Dispatch<SetStateAction<boolean>>;
}

const UserFirstTemplate = ({
  createLoading,
  editTemplate,
  setEditTemplate,
  followupTemplate,
  setFollowupTemplate,
  setIsDirty,
}: Props) => {
  const { outreachTemplates } = useContext(OutreachTemplatesContext);
  const [showFollowUp, setShowFollowUp] = useState(false);
  const [message, setMessage] = useState(loadingMessages[0]);

  useEffect(() => {
    let index = 0;
    if (createLoading) {
      const interval = setInterval(() => {
        index = (index + 1) % loadingMessages.length;
        setMessage(loadingMessages[index]);
      }, 2000);
      return () => clearInterval(interval); // cleanup
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createLoading]);

  return (
    <Box>
      <Box>
        {createLoading && (
          <>
            <Skeleton animation="wave" width="100%" height="50px" />
            <Skeleton
              animation="wave"
              width="100%"
              height="300px"
              sx={{ mt: -7, mb: -8 }}
            />
            <Skeleton animation="wave" width="100%" height="80px" />

            <Grid container justifyContent="center">
              <CircularProgress size={20} sx={{ mr: 2 }} />
              {message}
            </Grid>
          </>
        )}

        {!createLoading && <UtilizeMergeTags />}

        {!createLoading && (
          <TemplateBody
            editTemplate={editTemplate}
            setEditTemplate={setEditTemplate}
            isNew={!(outreachTemplates?.length > 0)}
            allowChangeTitle={false}
            displayError={true}
            setIsDirty={setIsDirty}
          />
        )}
      </Box>
      {!showFollowUp && !createLoading && (
        <Button
          size="small"
          sx={{ textTransform: "none", color: "purple.main" }}
          onClick={() => setShowFollowUp(true)}
        >
          Add Follow-Up
        </Button>
      )}

      {showFollowUp && !createLoading && (
        <Box sx={{ mt: 2 }}>
          <Grid container justifyContent={"space-between"}>
            <FormHelperText>Follow-up (optional):</FormHelperText>
            <Tooltip title="Remove follow-up">
              <IconButton
                sx={{ fontSize: 12 }}
                onClick={() => setShowFollowUp(false)}
              >
                <Box component="i" className="fa-regular fa-trash" />
              </IconButton>
            </Tooltip>
          </Grid>

          <TemplateBody
            editTemplate={followupTemplate}
            setEditTemplate={setFollowupTemplate}
            isNew={true}
            allowChangeTitle={false}
            displayError={true}
            setIsDirty={setIsDirty}
          />
        </Box>
      )}
    </Box>
  );
};

export default UserFirstTemplate;
